var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgShareGreen(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 15,
    viewBox: "0 0 18 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.38921 12.4582C1.93536 10.9953 2.70102 9.61449 3.73917 8.42803C5.3841 6.54812 7.74175 5.12206 11.0919 4.64347L11.65 4.56374V4V1.56924L17.0808 7L11.65 12.4308V9.9V9.25H11C6.97683 9.25 3.8327 10.262 1.38921 12.4582Z",
    stroke: "#51CDA0",
    strokeWidth: 1.3
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgShareGreen);
export default __webpack_public_path__ + "static/media/shareGreen.2cc6b90d60d8d2fdf43e69bc39836442.svg";
export { ForwardRef as ReactComponent };